var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlipCameraIos({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3334 1.95833H11.9584L10.375 0.375H5.62504L4.04171 1.95833H1.66671C0.795874 1.95833 0.083374 2.67083 0.083374 3.54167V13.0417C0.083374 13.9204 0.795874 14.625 1.66671 14.625H14.3334C15.2121 14.625 15.9167 13.9204 15.9167 13.0417V3.54167C15.9167 2.67083 15.2121 1.95833 14.3334 1.95833ZM2.45837 7.5H4.12087C4.55629 5.35458 6.64629 3.97708 8.79171 4.4125C9.39337 4.53125 9.92379 4.80042 10.375 5.125L9.23504 6.27292C8.87879 6.05125 8.45921 5.91667 8.00004 5.91667C7.00254 5.91667 6.10004 6.55 5.76754 7.5H7.20837L4.83337 9.875L2.45837 7.5ZM11.8871 9.08333C11.4517 11.2288 9.36171 12.6062 7.20837 12.1708C6.61462 12.0442 6.08421 11.7829 5.62504 11.4583L6.76504 10.3104C7.12921 10.5321 7.54879 10.6667 8.00004 10.6667C9.00546 10.6667 9.90796 10.0333 10.2405 9.08333H8.79171L11.1667 6.70833L13.5417 9.08333H11.8871Z",
    fill: "#D0E2FB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipCameraIos);
export default __webpack_public_path__ + "static/media/FlipCameraIos.580a8ba0.svg";
export { ForwardRef as ReactComponent };